// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"a1e2e28e","404":"65f13ac2","498":"91b2af31","787":"61b147b4"}[chunkId] + ".chunk.js";
};